import SearchPanel from '../../components/search-panel/SearchPanel';
import './search.scss';

export default function SearchPage() {

	return (
		<div className='searchPane'>
			<SearchPanel></SearchPanel>
		</div>
	)
}
